(function () {
  var STOREFRONT_DOMAIN = 'c2pyvu-yc.myshopify.com';
  var STOREFRONT_TOKEN = '8468db0844f318bfdb188358ea7aa08b';
  var STOREFRONT_API = 'https://' + STOREFRONT_DOMAIN + '/api/2024-01/graphql.json';

  function createCheckoutUrl(variantNumericId, sellingPlanNumericId) {
    var lineFields = 'merchandiseId: $variantId, quantity: 1';
    var queryHead = 'mutation CartCreate($variantId: ID!';
    var variables = { variantId: 'gid://shopify/ProductVariant/' + variantNumericId };

    if (sellingPlanNumericId) {
      queryHead += ', $sellingPlanId: ID';
      lineFields += ', sellingPlanId: $sellingPlanId';
      variables.sellingPlanId = 'gid://shopify/SellingPlan/' + sellingPlanNumericId;
    }

    var query =
      queryHead + ') {' +
      '  cartCreate(input: { lines: [{ ' + lineFields + ' }] }) {' +
      '    cart { checkoutUrl }' +
      '    userErrors { field message }' +
      '  }' +
      '}';

    return fetch(STOREFRONT_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query: query, variables: variables }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var result = data.data && data.data.cartCreate;
        if (result && result.userErrors && result.userErrors.length) {
          console.error('Shopify cart error:', result.userErrors);
          return null;
        }
        return result && result.cart ? result.cart.checkoutUrl : null;
      });
  }

  /* ── Nav scroll state ── */
  var nav = document.getElementById('pb-nav');
  if (nav) {
    var onScroll = function () {
      var scrolled = window.scrollY > 24;
      nav.style.background = scrolled ? 'rgba(255,245,250,.85)' : 'rgba(255,245,250,.55)';
      nav.style.borderBottom = scrolled ? '.5px solid var(--line)' : '.5px solid transparent';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Scroll-in reveal ── */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.pb-reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.pb-reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* ── Hero "Shop the Stick" scroll ── */
  var shopBtn = document.getElementById('pb-shop-btn');
  if (shopBtn) {
    shopBtn.addEventListener('click', function () {
      var el = document.getElementById('shop');
      if (el) window.scrollTo({ top: el.offsetTop - 20, behavior: 'smooth' });
    });
  }

  /* ── Before / after drag slider ── */
  var ba = document.getElementById('pb-ba');
  var baBeforeWrap = document.getElementById('pb-ba-before-wrap');
  var baHandle = document.getElementById('pb-ba-handle');
  if (ba && baBeforeWrap && baHandle) {
    var dragging = false;

    var setPos = function (p) {
      p = Math.max(0, Math.min(100, p));
      baBeforeWrap.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
      baHandle.style.left = p + '%';
    };

    var updateFromEvent = function (e) {
      var rect = ba.getBoundingClientRect();
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      var x = clientX - rect.left;
      setPos((x / rect.width) * 100);
    };

    ba.addEventListener('mousedown', function (e) { dragging = true; updateFromEvent(e); });
    ba.addEventListener('touchstart', function (e) { dragging = true; updateFromEvent(e); });
    window.addEventListener('mousemove', function (e) { if (dragging) updateFromEvent(e); });
    window.addEventListener('touchmove', function (e) { if (dragging) updateFromEvent(e); });
    window.addEventListener('mouseup', function () { dragging = false; });
    window.addEventListener('touchend', function () { dragging = false; });
  }

  /* ── Bundle picker ── */
  var bundleBtns = document.querySelectorAll('.pb-bundle-btn');
  var addBtn = document.getElementById('pb-add-btn');
  var addLabel = document.getElementById('pb-add-label');
  var addPrice = document.getElementById('pb-add-price');
  var afterpay = document.getElementById('pb-afterpay');

  function selectedBundle() {
    var el = document.querySelector('.pb-bundle-btn[data-selected="true"]');
    return {
      el: el,
      variantId: el.dataset.variantId,
      price: parseFloat(el.dataset.price),
      units: parseInt(el.dataset.units, 10),
    };
  }

  var subToggle = document.getElementById('pb-sub-toggle');
  var subLabel = subToggle ? subToggle.closest('.pb-sub-label') : null;

  function refreshBundleUI() {
    var b = selectedBundle();
    var subscribed = !!(subToggle && subToggle.checked);
    var price = subscribed ? b.price * 0.75 : b.price;

    if (addLabel) addLabel.textContent = 'Add ' + (b.units > 1 ? b.units + ' sticks' : 'to bag');
    if (addPrice) addPrice.textContent = '$' + price.toFixed(2);
    if (afterpay) afterpay.textContent = '4 interest-free payments of $' + (price / 4).toFixed(2) + ' with Afterpay';
  }

  bundleBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      bundleBtns.forEach(function (b) { delete b.dataset.selected; });
      btn.dataset.selected = 'true';
      refreshBundleUI();
    });
  });

  if (subLabel && subToggle) {
    subLabel.addEventListener('click', function (e) {
      e.preventDefault();
      subToggle.checked = !subToggle.checked;
      subLabel.dataset.checked = subToggle.checked ? 'true' : 'false';
      refreshBundleUI();
    });
  }

  refreshBundleUI();

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (addBtn.dataset.loading === 'true') return;

      var b = selectedBundle();
      var sellingPlanId = (subToggle && subToggle.checked) ? subToggle.dataset.sellingPlanId : null;
      var originalLabel = addLabel ? addLabel.textContent : '';
      addBtn.dataset.loading = 'true';
      if (addLabel) addLabel.textContent = 'Redirecting…';

      createCheckoutUrl(b.variantId, sellingPlanId).then(function (url) {
        if (url) {
          // Pass fbclid through to Shopify checkout so Meta's pixel
          // can attribute the purchase back to the original ad click.
          var fbclid = new URLSearchParams(window.location.search).get('fbclid');
          if (fbclid) {
            url += (url.indexOf('?') === -1 ? '?' : '&') + 'fbclid=' + encodeURIComponent(fbclid);
          }
          window.location.href = url;
        } else {
          addBtn.dataset.loading = 'false';
          if (addLabel) addLabel.textContent = originalLabel;
        }
      }).catch(function (err) {
        console.error('Checkout error:', err);
        addBtn.dataset.loading = 'false';
        if (addLabel) addLabel.textContent = originalLabel;
      });
    });
  }

  /* ── FAQ accordion ── */
  document.querySelectorAll('.pb-faq-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var willOpen = btn.dataset.open !== 'true';
      document.querySelectorAll('.pb-faq-btn').forEach(function (b) { b.dataset.open = 'false'; });
      btn.dataset.open = willOpen ? 'true' : 'false';
    });
  });

  /* ── Newsletter form ── */
  var form = document.getElementById('pb-newsletter-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var label = document.getElementById('pb-newsletter-btn-label');
      var sent = document.getElementById('pb-newsletter-sent');
      if (label) label.textContent = 'Sent ✓';
      if (sent) sent.style.display = 'block';
    });
  }

  /* ── Email capture popup ── */
  var popupOverlay = document.getElementById('pb-popup-overlay');
  var popup = document.getElementById('pb-popup');
  if (popupOverlay && popup) {
    var DISMISS_KEY = 'pbEmailPopupDismissed';
    var popupClose = document.getElementById('pb-popup-close');
    var popupForm = document.getElementById('pb-popup-form');
    var popupEmail = document.getElementById('pb-popup-email');
    var popupSubmitLabel = document.getElementById('pb-popup-submit-label');
    var popupCopyBtn = document.getElementById('pb-popup-copy-btn');
    var popupCopyLabel = document.getElementById('pb-popup-copy-label');

    var dismissed = false;
    try { dismissed = localStorage.getItem(DISMISS_KEY) === '1'; } catch (e) {}

    function openPopup() {
      popupOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      popupOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
      try { localStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
    }

    if (!dismissed) {
      setTimeout(openPopup, 6000);
    }

    if (popupClose) popupClose.addEventListener('click', closePopup);
    popupOverlay.addEventListener('click', function (e) {
      if (e.target === popupOverlay) closePopup();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popupOverlay.classList.contains('is-open')) closePopup();
    });

    if (popupForm) {
      popupForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = popupEmail ? popupEmail.value.trim() : '';
        if (!email) return;

        if (popupSubmitLabel) popupSubmitLabel.textContent = 'Unlocking…';

        var body = new URLSearchParams();
        body.set('form_type', 'customer');
        body.set('utf8', '✓');
        body.set('contact[email]', email);
        body.set('contact[tags]', 'newsletter,popup-first5');
        body.set('contact[accepts_marketing]', '1');

        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body.toString(),
        }).catch(function (err) {
          console.error('Newsletter capture error:', err);
        });

        popup.dataset.state = 'success';
        try { localStorage.setItem(DISMISS_KEY, '1'); } catch (err) {}
      });
    }

    if (popupCopyBtn) {
      popupCopyBtn.addEventListener('click', function () {
        var code = 'FIRST5';
        var showCopied = function () {
          if (popupCopyLabel) popupCopyLabel.textContent = 'Copied ✓';
          setTimeout(function () {
            if (popupCopyLabel) popupCopyLabel.textContent = 'Copy code';
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(showCopied).catch(showCopied);
        } else {
          showCopied();
        }
      });
    }
  }
})();
